import { JSX, Show } from "solid-js";
import { useTelescopeContext } from "@hubble/telescope";
import { createAutoAnimate } from "@formkit/auto-animate/solid";
import { useViewContext } from "../data/view_context";
import { PhosphorIcon } from "~/widgets/icons";
import { showSnackBar } from "~/shared_states/snackbar";
import { openModalV2 } from "~/shared_states/modal";
import { IndiryaTncsModal } from "./tnc_modal";

export function VoucherCard(props: {
  offerText: string;
  tncs: string[];
}): JSX.Element {
  const { components } = useTelescopeContext();
  const { isGenerating, voucher, generateVoucher } = useViewContext();
  const [parent] = createAutoAnimate();

  return (
    <div class="flex w-full max-w-[500px] flex-col items-center gap-6 rounded-2xl border border-stroke-1 bg-background-normal-primary p-6">
      {/* Logo */}
      {/* <img
        src="https://assets.myhubble.money/web-assets/corp-gifting/indriya_logo.jpeg"
        alt="indriya logo"
        class="h-[80px] w-[80px] rounded-full"
      /> */}

      {/* Offer Text */}
      <p class="text-center text-title-5-medium text-text-normal-primary sm:text-title-4-medium">
        {props.offerText}
      </p>

      {/* Animated container for button / voucher code swap */}
      <div ref={parent} class="flex w-full flex-col items-center">
        <Show
          when={!voucher()}
          fallback={
            <div class="flex w-full flex-col items-center gap-2 rounded-xl bg-background-normal-secondary px-4 py-4">
              <p class="text-para-3-regular text-text-normal-secondary">
                Your voucher code
              </p>
              <div
                class="flex cursor-pointer items-center gap-2"
                onClick={() => {
                  navigator.clipboard.writeText(voucher()!.cardNumber);
                  showSnackBar({
                    level: "success",
                    message: "Voucher code copied!",
                  });
                }}
              >
                <div
                  class="flex cursor-pointer items-center gap-2"
                  onClick={() => {
                    navigator.clipboard.writeText(voucher()!.cardNumber);
                    showSnackBar({
                      level: "success",
                      message: "Voucher code copied!",
                    });
                  }}
                >
                  <p class="text-title-4-medium tracking-wider text-text-normal-primary">
                    {voucher()!.cardNumber}
                  </p>
                  <PhosphorIcon
                    name="copy"
                    fontSize={18}
                    class="text-text-normal-secondary"
                  />
                </div>
              </div>
              <p class="text-center text-para-3-regular text-text-normal-secondary">
                Redeem this code at your nearest Indriya store
              </p>
            </div>
          }
        >
          <div class="w-full">
            <components.Button
              text="Generate Voucher"
              onClick={generateVoucher}
              variant="primary"
              style="neutral"
              size={40}
              loading={isGenerating()}
              disabled={isGenerating()}
              expanded={true}
            />
          </div>
        </Show>
      </div>
      <button
        onClick={() => {
          openModalV2(() => <IndiryaTncsModal tncs={props.tncs} />, {
            expandToFullHeight: true,
          });
        }}
        class="text-label-regular text-text-normal-secondary underline decoration-text-normal-secondary underline-offset-2"
      >
        Terms and Conditions
      </button>
    </div>
  );
}
